import { Card, Stack } from '@mui/material';
import { NumericFormat } from 'react-number-format';

import colors from '../../constants/colors';
import ReviewCardCommonEntry from '../../pages/Payment/components/ReviewCardCommonEntry';
import { usePaymentsContext } from '../../store/payments';

interface PaymentsCardsProps {
  policyNumbers: string[];
  showConfirmation?: boolean;
}

const PaymentsCards = ({
  policyNumbers,
  showConfirmation = false,
}: PaymentsCardsProps) => {
  const { state } = usePaymentsContext();

  return (
    <>
      {policyNumbers.map((policyNumber) => (
        <Card
          key={policyNumber}
          component={Stack}
          spacing={3}
          sx={{
            borderRadius: 2,
            height: 'auto',
            boxShadow: 'none',
            '& .MuiStack-root': { borderColor: colors.csaaBorder },
          }}
        >
          <Stack
            spacing={1}
            sx={{
              border: '1px solid',
              borderColor: colors.csaaLightBorder,
              borderRadius: 2,
              p: 3,
            }}
          >
            <ReviewCardCommonEntry
              label="Policy type"
              text={state.selectedPayments[policyNumber].policyType}
              className="csaa-qm-block"
              {...(showConfirmation
                ? {
                    failed: !!state.paymentDetails[policyNumber]?.receiptNumber,
                  }
                : {})}
            />
            <ReviewCardCommonEntry
              label="Policy number"
              text={policyNumber}
              className="csaa-qm-block"
            />
            {showConfirmation &&
              state.paymentDetails[policyNumber]?.receiptNumber && (
                <ReviewCardCommonEntry
                  label="Confirmation"
                  text={state.paymentDetails[policyNumber]?.receiptNumber}
                  className="csaa-qm-block"
                />
              )}
            <ReviewCardCommonEntry
              label="Payment amount"
              text={
                <NumericFormat
                  value={state.selectedPayments[policyNumber].amount}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                  fixedDecimalScale
                  decimalScale={2}
                />
              }
            />
          </Stack>
        </Card>
      ))}
    </>
  );
};

export default PaymentsCards;
